import { CodeIcon, ListIcon, ALargeSmallIcon } from 'lucide-vue-next';

export type FormatOption = 'markdown' | 'code' | 'choice';

export const FormatOptions = [
    {
        value: 'markdown',
        label: 'Markdown (Text)',
        icon: ALargeSmallIcon,
    },
    {
        value: 'code',
        label: 'Code',
        icon: CodeIcon,
    },
    {
        value: 'choice',
        label: 'Choice',
        icon: ListIcon,
    },
];
